import { Link } from "react-router-dom";
import SiteLayout from "@/components/site/SiteLayout";
import PageHero from "@/components/site/PageHero";
import { useI18n } from "@/lib/i18n";

export default function DlaPracownikow() {
  const { t, path } = useI18n();

  return (
    <SiteLayout>
      <PageHero eyebrow={t.employees.eyebrow} title={t.employees.title} description={t.employees.description} />

      <section className="py-16 lg:py-20 border-b border-border">
        <div className="mx-auto max-w-container px-6 lg:px-10">
          <div className="max-w-2xl mb-10 reveal">
            <div className="text-xs uppercase tracking-[0.18em] text-muted-foreground mb-4">{t.employees.flowEyebrow}</div>
            <h2 className="font-serif text-[36px] lg:text-[48px] leading-[1.1] tracking-tight">{t.employees.flowTitle}</h2>
          </div>
          <div className="grid md:grid-cols-2 gap-8 lg:gap-10">
            {t.employees.flow.map(([n, title, body]) => (
              <div key={n} className="reveal border-t border-border pt-6">
                <div className="font-serif text-xl text-muted-foreground mb-3">{n}</div>
                <h3 className="font-serif text-2xl mb-2">{title}</h3>
                <p className="text-muted-foreground leading-relaxed">{body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 lg:py-20 bg-secondary border-b border-border">
        <div className="mx-auto max-w-container px-6 lg:px-10 grid lg:grid-cols-2 gap-12 items-center">
          <div className="reveal">
            <div className="text-xs uppercase tracking-[0.18em] text-muted-foreground mb-4">{t.employees.personalizationEyebrow}</div>
            <h2 className="font-serif text-[36px] lg:text-[44px] leading-[1.1] tracking-tight mb-4">{t.employees.personalizationTitle}</h2>
            <p className="text-lg text-muted-foreground leading-relaxed mb-3">{t.employees.personalizationBody1}</p>
            <p className="text-lg text-muted-foreground leading-relaxed">{t.employees.personalizationBody2}</p>
          </div>

          <div className="reveal">
            <div className="relative aspect-[5/4] bg-card rounded-lg border border-border overflow-hidden shadow-[0_30px_80px_-30px_hsl(var(--primary)/0.18)]">
              <div className="absolute top-0 inset-x-0 flex items-center justify-between px-6 py-4 border-b border-border bg-card/80 backdrop-blur-sm z-10">
                <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground">{t.employees.mockupPreview}</div>
                <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground">1:1</div>
              </div>
              <svg viewBox="0 0 400 500" className="absolute inset-0 w-full h-full" preserveAspectRatio="xMidYMid meet" aria-hidden="true">
                <rect width="400" height="500" fill="hsl(var(--card))" />
                <path d="M 60 150 L 130 110 L 165 130 Q 200 165 235 130 L 270 110 L 340 150 L 320 220 L 320 470 L 80 470 L 80 220 Z" fill="hsl(var(--background))" stroke="hsl(var(--border))" strokeWidth="1.2" />
                <path d="M 165 130 Q 200 195 235 130" fill="none" stroke="hsl(var(--border))" strokeWidth="1.2" />
                <line x1="200" y1="195" x2="200" y2="470" stroke="hsl(var(--border))" strokeWidth="0.6" strokeDasharray="2 4" />
                <rect x="105" y="320" width="80" height="90" fill="none" stroke="hsl(var(--border))" strokeWidth="0.8" />
                <rect x="215" y="320" width="80" height="90" fill="none" stroke="hsl(var(--border))" strokeWidth="0.8" />
                <line x1="130" y1="110" x2="160" y2="195" stroke="hsl(var(--border))" strokeWidth="0.6" />
                <line x1="270" y1="110" x2="240" y2="195" stroke="hsl(var(--border))" strokeWidth="0.6" />
                <g>
                  <circle cx="100" cy="245" r="14" fill="none" stroke="hsl(var(--primary))" strokeWidth="1.2" />
                  <text x="100" y="249" textAnchor="middle" fill="hsl(var(--primary))" fontFamily="serif" fontSize="11" fontStyle="italic">A</text>
                  <text x="125" y="240" fill="hsl(var(--primary))" fontFamily="'Instrument Serif', serif" fontSize="20">{t.employees.mockupName}</text>
                  <text x="125" y="258" fill="hsl(var(--muted-foreground))" fontFamily="'Inter', sans-serif" fontSize="10" letterSpacing="0.5">{t.employees.mockupRole}</text>
                </g>
              </svg>
              <div className="absolute bottom-0 inset-x-0 flex items-center justify-between px-6 py-4 border-t border-border bg-card/80 backdrop-blur-sm">
                <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground">{t.employees.mockupFooter}</div>
                <div className="inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] text-muted-foreground"><span className="h-1.5 w-1.5 rounded-full bg-primary" />{t.employees.mockupApproved}</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 lg:py-20">
        <div className="mx-auto max-w-container px-6 lg:px-10 text-center reveal">
          <h2 className="font-serif text-[36px] lg:text-[52px] leading-[1.05] tracking-tight max-w-2xl mx-auto">{t.employees.ctaTitle}</h2>
          <p className="mt-4 text-lg text-muted-foreground leading-relaxed max-w-xl mx-auto">{t.employees.ctaBody}</p>
          <Link to={path("contact")} className="mt-7 inline-flex items-center rounded-md bg-primary px-7 py-3.5 text-sm font-medium text-primary-foreground hover:bg-primary/90 transition-colors">{t.employees.ctaButton}</Link>
        </div>
      </section>
    </SiteLayout>
  );
}
